import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookie-toast-wrap"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "cookie-toast" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "links" }
const _hoisted_9 = { class: "item action" }
const _hoisted_10 = { class: "item tech" }
const _hoisted_11 = { class: "item custom" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "list-item" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = {
  class: "info",
  "data-full": ""
}
const _hoisted_16 = { class: "type" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "type" }
const _hoisted_20 = { class: "action" }
const _hoisted_21 = { class: "confirm" }

import { ref, computed, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'CookieToast',
  setup(__props) {

const store = useStore();

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isCustomize = ref(false);
const isActivateStatistics = ref(false);
const isActivateProfiling = ref(false);
const cookiePolicyUrl = ref<string>(null);
const customizeCookieValues = ref<string[]>(["tech"]);

const isCookieToastVisible = computed(() => {
    return store.getters["cookieToastStore/isCookieToastVisible"];
});

watch(isCookieToastVisible, async (newValue: boolean) => {
    isLoading.value = true;

    store.commit("cookieToastStore/setCookieToastVisible", newValue);

    isLoading.value = false;
});

onBeforeMount(() => {
    if (!CookieHelper.isCookiePolicy()) {
        store.commit("cookieToastStore/setCookieToastVisible", true);
    }
});

function setCustomize() {
    isCustomize.value = !isCustomize.value;
}

function setStatistics() {
    isActivateStatistics.value = !isActivateStatistics.value;

    if (isActivateStatistics.value) {
        customizeCookieValues.value.push("stat");
    } else {
        let index = customizeCookieValues.value.indexOf("stat");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setProfiling() {
    isActivateProfiling.value = !isActivateProfiling.value;

    if (isActivateProfiling.value) {
        customizeCookieValues.value.push("profile");
    } else {
        let index = customizeCookieValues.value.indexOf("profile");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setCookieToast() {
    CookieHelper.setCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setOnlyTech() {
    CookieHelper.removeCookiePolicyAll();
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

function setCustomCookie() {
    CookieHelper.setCookie("ckp", customizeCookieValues.value.join("|"), 365);
    store.commit("cookieToastStore/setCookieToastVisible", false);
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (isCookieToastVisible.value && !isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setOnlyTech())),
              class: "close"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("img", {
                src: "/Images/close.svg",
                width: "18",
                height: "18",
                class: "image",
                alt: "Close"
              }, null, -1)
            ]))]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: "/Images/cookie.svg",
                  class: "icon",
                  alt: _unref(localizer).get('CookieToast.Common.CookiePolicy')
                }, null, 8, _hoisted_6),
                _createTextVNode(_toDisplayString(_unref(localizer).get("CookieToast.Common.CookiePolicy")), 1)
              ]),
              _createElementVNode("span", {
                innerHTML: _unref(localizer).get('CookieToast.Common.Description', _unref(routes).Terms_CookiePolicy)
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setCookieToast())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.AgreeAll")), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (setOnlyTech())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.OnlyTechnicians")), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (setCustomize())),
                  class: "button",
                  "data-border": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Customize")), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['customize', !isCustomize.value ? 'hden' : ''])
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(localizer).get("CookieToast.Common.CustomizeTitle")), 1),
              _createTextVNode(" " + _toDisplayString(_unref(localizer).get("CookieToast.Common.CustomizeDescription")) + " ", 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(localizer).get("CookieToast.Common.Technicians")), 1),
                    _cache[8] || (_cache[8] = _createTextVNode(" Google Analytics, Google.com ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(localizer).get("CookieToast.Common.Profiling")), 1),
                    _cache[9] || (_cache[9] = _createTextVNode(" Facebook (FB) ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (isActivateProfiling.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (setProfiling())),
                          class: "button",
                          "data-border": ""
                        }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Deactivate")), 1))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (setProfiling())),
                          class: "button",
                          "data-border": ""
                        }, _toDisplayString(_unref(localizer).get("CookieToast.Common.Activate")), 1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (setCustomCookie())),
                  class: "button",
                  "data-accent": ""
                }, _toDisplayString(_unref(localizer).get("CookieToast.Common.SavePreferences")), 1)
              ])
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})